/**
 * Enum specifying the direction for animations, popovers, or dropdowns.
 */
export var Direction;
(function (Direction) {
    Direction["None"] = "";
    Direction["Bottom"] = "bottom";
    Direction["Left"] = "left";
    Direction["Right"] = "right";
    Direction["Top"] = "top";
})(Direction || (Direction = {}));
//# sourceMappingURL=Direction.js.map